import React from 'react'

import { Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

interface ProfileFormContentProps {
  children: React.ReactNode
  title?: string
  subTitle?: string
  stepTitle?: string
  stepDescription?: string
  titlesAlign?: 'left' | 'right' | 'center'
  containerClassName?: string
}

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 36,
    fontWeight: 700,
    lineHeight: '38px',
    marginBottom: 16,
  },
  stepTitle: {
    fontWeight: 600,
    fontSize: 20,
    lineHeight: '18px',
    marginBottom: 16,
  },
  stepDescription: {
    marginBottom: 16,
  },
  subTitle: {
    marginBottom: 32,

    [theme.breakpoints.down('sm')]: {
      marginBottom: 24,
    },
  },
}))

const ProfileFormWrapper = ({
  children,
  title = '',
  subTitle = '',
  stepTitle = '',
  stepDescription = '',
  titlesAlign = 'left',
  containerClassName = '',
}: ProfileFormContentProps) => {
  const classes = useStyles()

  return (
    <Grid className={containerClassName}>
      {title ? (
        <Typography
          component="h2"
          className={classes.title}
          textAlign={titlesAlign}
        >
          {title}
        </Typography>
      ) : null}
      {subTitle ? (
        <Typography className={classes.subTitle} textAlign={titlesAlign}>
          {subTitle}
        </Typography>
      ) : null}
      {stepTitle ? (
        <Typography
          component="h3"
          className={classes.stepTitle}
          textAlign={titlesAlign}
        >
          {stepTitle}
        </Typography>
      ) : null}
      {stepDescription ? (
        <Typography className={classes.stepDescription} textAlign={titlesAlign}>
          {stepDescription}
        </Typography>
      ) : null}
      <Grid container flexDirection="column" flexWrap="nowrap" flexGrow="1">
        {children}
      </Grid>
    </Grid>
  )
}

export default ProfileFormWrapper
